import { GlobalArea } from '@libs/templates/global-area';
import { ErrorBoundary } from '@libs/templates/template-pages';
import { Outlet, Route } from 'react-router-dom';

export const userRouter = (
  <Route
    path="/user"
    element={
      <>
        <GlobalArea isUnderSubsystem={false} />
        <Outlet />
      </>
    }
    errorElement={<ErrorBoundary isUnderSubsystem={false} />}
  >
    <Route path="/user/change-password" lazy={async () => import('./pages/ChangePassword')} />
  </Route>
);
